import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './KeyFinancialRatios.css';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import { useParams } from "react-router-dom";
import CompanyProfileOptions from "../../CompanyProfileOptions/CompanyProfileOptions";
import { Vortex } from 'react-loader-spinner'

function KeyFinancialRatios() {
    const [showResults, setShowResults] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [setTextval, setText] = useState([]);
    const [compCode, setCompCode] = useState('');
    const [nameCom, setNameCom] = useState([]);
    const [groupValue, setGroupValue] = useState("Consolidated");
    let DataFilter = [];
    let getval = [];
    let matchcomp = [];
    const { getCompName } = useParams();
    const [data, setData] = useState([]);
    const [dataSort, setDataSort] = useState([]);
    const [dataSort1, setDataSort1] = useState([]);
    const [dataSort2, setDataSort2] = useState([]);
    const [dataSort3, setDataSort3] = useState([]);
    const [dataSort4, setDataSort4] = useState([]);
    const [dataCol, setDataCol] = useState([]);
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [co_code, setco_code] = useState([]);
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;
    let arrayData = [], arrayDataCol = [], arrayColumnData = [];
    let arrayColumn = [];
    let dataGet, finalData, dataGet1, finalData1, dataGet2, finalData2;
    let dataGet3, finalData3, dataGet4, finalData4, getDataCol;
    useEffect(() => {
        setloadingshow(true);
        if (co_code != '') {
            if (groupValue === "Consolidated") {
                const getUrl = BaseURL + "KeyFinancialRatios";
                fetch(`${getUrl}/${co_code}/MAN/5`)
                    .then((response) => response.json())
                    .then((data) => {
                        getData = data.data;
                        setData(getData);
                        setloadingshow(false);
                        //console.log(getData, "getData")
                    })
                    .catch((error) => {
                    });
                const getUrlCol = BaseURL + "KeyFinancialRatiosCol";
                fetch(`${getUrlCol}/${co_code}/MAN/5`)
                    .then((response) => response.json())
                    .then((dataCol) => {
                        getDataCol = dataCol.data;
                        setDataCol(getDataCol);
                        //console.log(getDataCol, "KeyFinancialRatiosCol");
                        if (getDataCol[2].slice(-2) === "12") {
                            dataGet = getDataCol[2].slice(0, -2).split('Y')[1];
                            finalData = "Dec " + dataGet;
                            setDataSort(finalData);
                        }
                        if (getDataCol[2].slice(-2) === "03") {
                            dataGet = getDataCol[2].slice(0, -2).split('Y')[1];
                            finalData = "March " + dataGet;
                            setDataSort(finalData);
                        }
                        if (getDataCol[3].slice(-2) === "12") {
                            dataGet1 = getDataCol[3].slice(0, -2).split('Y')[1];
                            finalData1 = "Dec " + dataGet1;
                            setDataSort1(finalData1);
                        }
                        if (getDataCol[3].slice(-2) === "03") {
                            dataGet1 = getDataCol[3].slice(0, -2).split('Y')[1];
                            finalData1 = "March " + dataGet1;
                            setDataSort1(finalData1);
                        }
                        if (getDataCol[4].slice(-2) === "12") {
                            dataGet2 = getDataCol[4].slice(0, -2).split('Y')[1];
                            finalData2 = "Dec " + dataGet2;
                            setDataSort2(finalData2);
                        }
                        if (getDataCol[4].slice(-2) === "03") {
                            dataGet2 = getDataCol[4].slice(0, -2).split('Y')[1];
                            finalData2 = "March " + dataGet2;
                            setDataSort2(finalData2);
                        }
                        if (getDataCol[5].slice(-2) === "12") {
                            dataGet3 = getDataCol[5].slice(0, -2).split('Y')[1];
                            finalData3 = "Dec " + dataGet3;
                            setDataSort3(finalData3);
                        }
                        if (getDataCol[5].slice(-2) === "03") {
                            dataGet3 = getDataCol[5].slice(0, -2).split('Y')[1];
                            finalData3 = "March " + dataGet3;
                            setDataSort3(finalData3);
                        }
                        if (getDataCol[6].slice(-2) === "12") {
                            dataGet4 = getDataCol[6].slice(0, -2).split('Y')[1];
                            finalData4 = "Dec " + dataGet4;
                            setDataSort4(finalData4);
                        }
                        if (getDataCol[6].slice(-2) === "03") {
                            dataGet4 = getDataCol[6].slice(0, -2).split('Y')[1];
                            finalData4 = "March " + dataGet4;
                            setDataSort4(finalData4);
                        }
                    })
                    .catch((error) => {
                    });
            } else {
                const getUrl = BaseURL + "KeyFinancialRatiosStandard";
                fetch(`${getUrl}/${co_code}/MAN/5`)
                    .then((response) => response.json())
                    .then((data) => {
                        getData = data.data;
                        setData(getData);
                        setloadingshow(false);
                        //console.log(getData, "getData")
                    })
                    .catch((error) => {
                    });
                const getUrlCol = BaseURL + "KeyFinancialRatiosColStandard";
                fetch(`${getUrlCol}/${co_code}/MAN/5`)
                    .then((response) => response.json())
                    .then((dataCol) => {
                        getDataCol = dataCol.data;
                        setDataCol(getDataCol);
                        //console.log(getDataCol, "KeyFinancialRatiosCol");
                        if (getDataCol[2].slice(-2) === "12") {
                            dataGet = getDataCol[2].slice(0, -2).split('Y')[1];
                            finalData = "Dec " + dataGet;
                            setDataSort(finalData);
                        }
                        if (getDataCol[2].slice(-2) === "03") {
                            dataGet = getDataCol[2].slice(0, -2).split('Y')[1];
                            finalData = "March " + dataGet;
                            setDataSort(finalData);
                        }
                        if (getDataCol[3].slice(-2) === "12") {
                            dataGet1 = getDataCol[3].slice(0, -2).split('Y')[1];
                            finalData1 = "Dec " + dataGet1;
                            setDataSort1(finalData1);
                        }
                        if (getDataCol[3].slice(-2) === "03") {
                            dataGet1 = getDataCol[3].slice(0, -2).split('Y')[1];
                            finalData1 = "March " + dataGet1;
                            setDataSort1(finalData1);
                        }
                        if (getDataCol[4].slice(-2) === "12") {
                            dataGet2 = getDataCol[4].slice(0, -2).split('Y')[1];
                            finalData2 = "Dec " + dataGet2;
                            setDataSort2(finalData2);
                        }
                        if (getDataCol[4].slice(-2) === "03") {
                            dataGet2 = getDataCol[4].slice(0, -2).split('Y')[1];
                            finalData2 = "March " + dataGet2;
                            setDataSort2(finalData2);
                        }
                        if (getDataCol[5].slice(-2) === "12") {
                            dataGet3 = getDataCol[5].slice(0, -2).split('Y')[1];
                            finalData3 = "Dec " + dataGet3;
                            setDataSort3(finalData3);
                        }
                        if (getDataCol[5].slice(-2) === "03") {
                            dataGet3 = getDataCol[5].slice(0, -2).split('Y')[1];
                            finalData3 = "March " + dataGet3;
                            setDataSort3(finalData3);
                        }
                        if (getDataCol[6].slice(-2) === "12") {
                            dataGet4 = getDataCol[6].slice(0, -2).split('Y')[1];
                            finalData4 = "Dec " + dataGet4;
                            setDataSort4(finalData4);
                        }
                        if (getDataCol[6].slice(-2) === "03") {
                            dataGet4 = getDataCol[6].slice(0, -2).split('Y')[1];
                            finalData4 = "March " + dataGet4;
                            setDataSort4(finalData4);
                        }
                    })
                    .catch((error) => {
                    });
            }
        }

    }, [co_code, groupValue]);

    useEffect(() => {
        const getUrlchart = BaseURL + "getCo_Code";
        fetch(`${getUrlchart}/${getCompName}`)
            .then((response) => response.json())
            .then((data) => {
                setco_code(data.data[0]["co_code"]);
                setNameCom(data.data[0]["lname"]);
                //console.log(data)
            })
            .catch((error) => {
                //console.log("not found the api");
            });
        const getUrl = BaseURL + "GroupCoCode";
        fetch(`${getUrl}`)
            .then((response) => response.json())
            .then((dataGroup) => {
                getDataGroup = dataGroup.data;
                setDataGroup(getDataGroup);
                // console.log(getDataGroup, "getDataGroup");
            })
            .catch((error) => {
                //console.log("not found the api");
            });
    }, []);

    useEffect(() => {
        setloadingshow(true);
        dataGroup.filter(item => {
            if (item.CO_CODE === co_code) {
                const getUrl = BaseURL + "KeyFinancialRatios";
                fetch(`${getUrl}/${co_code}/BANK/5`)
                    .then((response) => response.json())
                    .then((data) => {
                        getData = data.data;
                        setData(getData);
                        setloadingshow(false);
                        //console.log(getData, "getData")
                    })
                    .catch((error) => {
                    });
                const getUrlCol = BaseURL + "KeyFinancialRatiosCol";
                fetch(`${getUrlCol}/${co_code}/BANK/5`)
                    .then((response) => response.json())
                    .then((dataCol) => {
                        getDataCol = dataCol.data;
                        setDataCol(getDataCol);
                        //console.log(getDataCol, "KeyFinancialRatiosCol");
                        if (getDataCol[2].slice(-2) === "12") {
                            dataGet = getDataCol[2].slice(0, -2).split('Y')[1];
                            finalData = "Dec " + dataGet;
                            setDataSort(finalData);
                        }
                        if (getDataCol[3].slice(-2) === "12") {
                            dataGet1 = getDataCol[3].slice(0, -2).split('Y')[1];
                            finalData1 = "Dec " + dataGet1;
                            setDataSort1(finalData1);
                        }
                        if (getDataCol[4].slice(-2) === "12") {
                            dataGet2 = getDataCol[4].slice(0, -2).split('Y')[1];
                            finalData2 = "Dec " + dataGet2;
                            setDataSort2(finalData2);
                        }
                        if (getDataCol[5].slice(-2) === "12") {
                            dataGet3 = getDataCol[5].slice(0, -2).split('Y')[1];
                            finalData3 = "Dec " + dataGet3;
                            setDataSort3(finalData3);
                        }
                        if (getDataCol[6].slice(-2) === "12") {
                            dataGet4 = getDataCol[6].slice(0, -2).split('Y')[1];
                            finalData4 = "Dec " + dataGet4;
                            setDataSort4(finalData4);
                        }
                        if (getDataCol[2].slice(-2) === "03") {
                            dataGet = getDataCol[2].slice(0, -2).split('Y')[1];
                            finalData = "March " + dataGet;
                            setDataSort(finalData);
                        }
                        if (getDataCol[3].slice(-2) === "03") {
                            dataGet1 = getDataCol[3].slice(0, -2).split('Y')[1];
                            finalData1 = "March " + dataGet1;
                            setDataSort1(finalData1);
                        }
                        if (getDataCol[4].slice(-2) === "03") {
                            dataGet2 = getDataCol[4].slice(0, -2).split('Y')[1];
                            finalData2 = "March " + dataGet2;
                            setDataSort2(finalData2);
                        }
                        if (getDataCol[5].slice(-2) === "03") {
                            dataGet3 = getDataCol[5].slice(0, -2).split('Y')[1];
                            finalData3 = "March " + dataGet3;
                            setDataSort3(finalData3);
                        }
                        if (getDataCol[5].slice(-2) === "03") {
                            dataGet4 = getDataCol[6].slice(0, -2).split('Y')[1];
                            finalData4 = "March " + dataGet4;
                            setDataSort4(finalData4);
                        }

                    })
                    .catch((error) => {
                    });
            }
        })
    }, [co_code]);

    if (data != null) {
        for (let [key, value1] of Object.entries(data)) {
            if (value1.COLUMNNAME !== "Year End") {
                for (let [key, value] of Object.entries(value1)) {
                    if (value1.COLUMNNAME != null) {
                        if (value1.COLUMNNAME.includes(":")) {
                            arrayDataCol.push(<td className="headingFin"><b>{(value != null) ? ((typeof value === 'number') ? value.toFixed(2) : value) : '-'}</b></td>);
                        }
                        else {
                            arrayDataCol.push(<td>{(value != null) ? ((typeof value === 'number') ? value.toFixed(2) : value) : '-'}</td>);
                        }
                    }
                }
                arrayData.push(<tr>{arrayDataCol}</tr>);
                arrayColumn.push(<tr>{arrayColumnData}</tr>);
                arrayDataCol = [];
                arrayColumnData = [];
            }
        }
    }


    return (
        <>
            <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/CompanyProfile/Get-Quotes">Company Profile</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Key Financial Ratios</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='share-loser-sc'>
                            <div className='score-header'>
                                <h2><span>Key Financial Ratios</span></h2>
                            </div>
                            <CompanyProfileOptions compOption="Key Financial Ratios" />
                            <div>
                                <h4 className="text-center comp-name">{(nameCom != null) ? nameCom : ''}</h4>
                            </div>
                            <div className='key-right'>
                                <div className='key-inner-select'>

                                    {/* aria-label="Select Consolidated" */}
                                    <select aria-label="Select Consolidated" onChange={(event) => { setGroupValue(event.target.value); }}>
                                        <option value="Consolidated" selected>Consolidated</option>
                                        <option value="Standalone">Standalone</option>
                                    </select>
                                </div>
                            </div>
                            <div className="table-class">
                                <div className='key-table table-responsive'>
                                    <table className='table'>
                                        <thead>
                                            {/* {arrayColumn[0]} */}
                                            {(dataCol === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}

                                            {dataCol != null ?
                                                <tr>
                                                    <th>Particulars</th>
                                                    <th>{dataSort}</th>
                                                    <th>{dataSort1}</th>
                                                    <th>{dataSort2}</th>
                                                    <th>{dataSort3}</th>
                                                    <th>{dataSort4}</th>
                                                </tr> : ''
                                            }
                                        </thead>
                                        <tbody>
                                            {arrayData}
                                        </tbody>
                                    </table>
                                    {loadingshow ? <div className="textcentervertex">
                                        <Vortex
                                            visible={true}
                                            height="80"
                                            width="80"
                                            ariaLabel="vortex-loading"
                                            wrapperStyle={{}}
                                            wrapperClass="vortex-wrapper"
                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                        />
                                        <div className="model_popup">Please Wait...</div>
                                    </div> : ""
                                    }
                                </div>
                            </div>
                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default KeyFinancialRatios;